import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { normalizeSocialLink as n } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as m } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as i } from "../../../store/index.mjs";
import { StoreImageEnum as d } from "../../../enums/store-image-enum.mjs";
const b = ({ profile: e, socialLinks: l }) => {
  const { locale: a } = i();
  return /* @__PURE__ */ o(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-8 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ r(
          s,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: d.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ o("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ r(
            "h1",
            {
              id: "region-heading",
              lang: a,
              className: "break-all text-center text-[28px] font-bold leading-[36px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ r(
            "span",
            {
              lang: a,
              className: "hyphens-auto text-center text-base font-normal text-[#F1F4F8]",
              children: e.bio
            }
          )
        ] }),
        !!l.length && /* @__PURE__ */ r("div", { className: "z-1 flex flex-wrap items-center justify-center gap-4", children: l.map((t) => /* @__PURE__ */ r(
          "a",
          {
            "aria-label": t.type,
            href: n(t),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: m(t.type, "fill-THEME-primary")
          },
          t.type
        )) }),
        /* @__PURE__ */ r(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
};
export {
  b as ProfileSolarized
};
